export const banfsag = "#212121"
export const light = "#fafafa"
export const dark = "#212121"